import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PageHeader } from '../../../commons/component/PageHeader/PageHeader';
import { AppState } from '../../../redux/reducers';
import { Settlement } from '../../../models/Entities/Settlements/Settlement';
import { resolveSettlementKind, SettlementKind } from '../../../functions/SettlementKind.Functions';
import ProviderSettlementDetailsComponent from '../../../components/Settlements/ProviderSettlementDetails/ProviderSettlementDetails.Component';

// components
import SettlementHeaderComponent from '../../../components/Settlements/SettlementtHeader/SettlementHeader.Component';
import SettlementResumeListComponent from '../../../components/Settlements/SettlementResumeList/SettlementResumeList.Component';
import SettlementTotalComponent from '../../../components/Settlements/SettlementTotal/SettlementTotal.Component';
import SettlementProtocolBreakdownComponent from '../../../components/Settlements/SettlementProtocolBreakdown/SettlementProtocolBreakdown.Component';
import SettlementConceptsBreakdownComponent from '../../../components/Settlements/SettlementConceptsBreakdown/SettlementConceptsBreakdown.Component';
import SettlementInvoiceUploadComponent from '../../../components/Settlements/SettlementInvoiceUpload/SettlementInvoiceUpload.Component';

////i18Next
import { useTranslation } from 'react-i18next';

//styles
import './SettlementDetails.Styles.css';

export const SettlementDetailsPage = () => {

  const { SettlementId } = useParams();
  const [t] = useTranslation();
  // Tipo de la liquidación del store (la pide la cabecera): la de proveedor tiene su propio detalle (spec 010 US4).
  // Mientras la liquidación no llegó, 'loading': no se monta ningún cuerpo para no pedir lo que no corresponde.
  const kind: SettlementKind | 'loading' = useSelector((state: AppState) => {
    const settlement = state.Settlement?.list?.find((item: Settlement) => item.id === Number(SettlementId));
    return settlement ? resolveSettlementKind(settlement) : 'loading';
  });

  return (
    <>
        <PageHeader title={t('settlementDetailsPage.settlementDetailsTitle')}/>
        <SettlementInvoiceUploadComponent SettlementId={Number(SettlementId)}>
        {(upload) => (
        <div className="sd-page">
            <SettlementHeaderComponent
                SettlementId={Number(SettlementId)}
                onUploadInvoice={upload.openUpload}
                uploadInvoiceDisabledReason={upload.disabledReason}
            />
            <div className="sd-content">
                <div className="sd-main">
                    {kind === 'provider' ? (
                        <ProviderSettlementDetailsComponent SettlementId={Number(SettlementId)} />
                    ) : kind === 'loading' ? null : (
                        <>
                            <SettlementResumeListComponent SettlementId={Number(SettlementId)} />
                            {/* Al pie del detalle: cuánto se cobró por cada concepto */}
                            <SettlementConceptsBreakdownComponent SettlementId={Number(SettlementId)} />
                        </>
                    )}
                </div>
                <aside className="sd-sidebar">
                    <SettlementTotalComponent SettlementId={Number(SettlementId)} />
                    {/* Sólo aparece en liquidaciones a médico o con varios protocolos */}
                    <SettlementProtocolBreakdownComponent SettlementId={Number(SettlementId)} />
                </aside>
            </div>
        </div>
        )}
        </SettlementInvoiceUploadComponent>
    </>
  );
};
